import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Accordion } from './Accordion';
import { BONUSES } from '../data/content';
export function Bonuses() {
  return <section className="px-5 py-10" data-id="element-27">
      <div className="mx-auto max-w-md" data-id="element-28">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-29">
          Para que seas el más completo, te llevas estas herramientas
        </h2>

        <div className="mx-auto mt-4 flex w-fit items-center gap-2 rounded-full border border-[#F5C518]/40 bg-[#F5C518]/10 px-4 py-1.5" data-id="element-30">
          <GiftIcon className="h-4 w-4 text-[#F5C518]" data-id="element-31" />
          <span className="text-sm font-700 uppercase tracking-wide text-[#F5C518]" data-id="element-32">
            Gratis solo por hoy
          </span>
        </div>

        <div className="mt-6 space-y-3" data-id="element-33">
          {BONUSES.map((b, i) => <Accordion key={i} emoji={b.emoji} title={b.title} previewImage={b.image} data-id="element-34">
              <p className="text-[14px] leading-snug text-neutral-300" data-id="element-35">
                {b.description}
              </p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}